module.exports = __webpack_public_path__ + "img/zikuang.51a41d78.jpg";